// Filter types and constants
export const PRODUCT_FILTER_VALUES = ['all', 'fence-replacement', 'driveway-installation', 'landscaping-design', 'online-services'] as const;
export type ProductFilter = (typeof PRODUCT_FILTER_VALUES)[number];

export const STATUS_FILTER_VALUES = ['active', 'on_hold'] as const;
export type StatusFilter = (typeof STATUS_FILTER_VALUES)[number];

export const SORT_OPTIONS_VALUES = ['last_activity_date', 'created_at'] as const;
export type SortOption = (typeof SORT_OPTIONS_VALUES)[number];

// Dropdown item type
type DropdownItem = {
  label: string;
  onClick: () => void;
  selected: boolean;
};

// Label getters
export const getProductLabel = (filter: ProductFilter): string => {
  const labels: Record<ProductFilter, string> = {
    all: 'All',
    'fence-replacement': 'Fence',
    'driveway-installation': 'Driveway',
    'landscaping-design': 'Landscaping',
    'online-services': 'Online Services',
  };
  return labels[filter];
};

export const getStatusLabel = (filter: StatusFilter): string => {
  const labels: Record<StatusFilter, string> = {
    active: 'Active',
    on_hold: 'On Hold',
  };
  return labels[filter];
};

export const getSortLabel = (sort: SortOption): string => {
  const labels: Record<SortOption, string> = {
    last_activity_date: 'Last Activity',
    created_at: 'Created Date',
  };
  return labels[sort];
};

// Dropdown item generators
export const getProductFilterItems = (
  current: ProductFilter,
  onChange: (value: ProductFilter) => void,
): DropdownItem[] => [
  { label: 'All', onClick: () => onChange('all'), selected: current === 'all' },
  { label: 'Fence', onClick: () => onChange('fence-replacement'), selected: current === 'fence-replacement' },
  { label: 'Driveway', onClick: () => onChange('driveway-installation'), selected: current === 'driveway-installation' },
  { label: 'Landscaping', onClick: () => onChange('landscaping-design'), selected: current === 'landscaping-design' },
  { label: 'Online Services', onClick: () => onChange('online-services'), selected: current === 'online-services' },
];

export const getStatusFilterItems = (
  current: StatusFilter,
  onChange: (value: StatusFilter) => void,
): DropdownItem[] => [
  { label: 'Active', onClick: () => onChange('active'), selected: current === 'active' },
  { label: 'On Hold', onClick: () => onChange('on_hold'), selected: current === 'on_hold' },
];

export const getSortItems = (
  current: SortOption,
  onChange: (value: SortOption) => void,
): DropdownItem[] => [
  { label: 'Last Activity', onClick: () => onChange('last_activity_date'), selected: current === 'last_activity_date' },
  { label: 'Created Date', onClick: () => onChange('created_at'), selected: current === 'created_at' },
];
